module.exports = __webpack_public_path__ + "static/img/2198_phase_function_Paper_Points.955ac45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2198_phase_function_Paper_Points.png
// module id = Rgjv
// module chunks = 0